export const taskOptions = ['All', 'Chat-completion', 'Embeddings']
export const modelFamilyOptions = ['All providers', 'AI21 Labs', 'Cohere', 'Meta', 'Mistral AI', 'Microsoft', 'OpenAI']
export const categoryOptions = [
  'All',
  'agents',
  'conversation',
  'large context',
  'low latency',
  'multilingual',
  'multimodal',
  'multipurpose',
  'rag',
  'reasoning',
  'understanding',
]
